import React, { useEffect, useState } from "react";
import { SeatingService, TransRoutesService } from "../../services";
import moment from 'moment';


const LunchSection = ({seatingLayout, lunchRecords, sectionName, confirmHasLunch, removeLunchRecord, selectedDate, refreshRecords, canEdit = false}) => {
	const [customers, setCustomers] = useState([]);

	const createLunchForAll = async () => {
		const dateStr = moment(selectedDate || new Date()).format('MM/DD/YYYY');
		const unconfirmed = customers.filter(c => !c.has_lunch);
		for (const c of unconfirmed) {
			await TransRoutesService.createLunchRecords({
				customer_id: c?.customer_id,
				customer_name: c?.customer_name,
				has_lunch: true,
				date: dateStr,
				create_by: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name,
				create_date: new Date(),
				edit_history: [{
					employee: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name,
					date: new Date()
				}]
			})
		};
		if (refreshRecords) refreshRecords();
	}

	useEffect(() => {
		const chartCustomers = SeatingService.getAllCustomersFromSeatingChart(
			seatingLayout,
			lunchRecords || [],
			'has_lunch'
		);
		setCustomers(chartCustomers);
	}, [lunchRecords, seatingLayout]);



	
  
  return (
    <>
      <div className="text-primary mb-4"><h5>{sectionName} {` (${customers?.length})`}</h5></div>
	  {canEdit && customers?.some(c => !c.has_lunch) && (<div className="mb-2 mt-2"><button onClick={() => createLunchForAll()} className="btn btn-primary btn-sm">Confirm All Lunch</button></div>)}
      <div className="list row">
        <div className="col-md-12">
					<table className="personnel-info-table">
            <thead>
              <tr>
								<th>Name</th>
								<th>Has Lunch Today</th>
								{canEdit && <th>Change Lunch Status</th>}
							</tr>
						</thead>
					<tbody>
						{
							customers?.map((customer) => (
								<tr key={customer?.customer_id} className={customer?.has_lunch ? 'light-green' : 'red'}>
									<td>{customer?.customer_name}</td>
									<td>{customer?.has_lunch ? 'Yes': 'No'}</td>
									{canEdit && <td>
										{!customer?.has_lunch && <button className="btn btn-link btn-sm" onClick={() => confirmHasLunch(customer)}>Confirm Customer Has Lunch</button>}
										{customer?.has_lunch && <button className="btn btn-link btn-sm" onClick={() => removeLunchRecord(customer?.customer_id)}>Mark Customer NOT have lunch</button>}
									</td>}
								</tr>
							))
						}
					</tbody>
					</table>
        </div>
      </div>
    </>
    
  );
};

export default LunchSection;